import { FC } from "react";
import { Spinner } from "@chakra-ui/react";
import { primaryColor } from "../../../utils/colors";

interface SpinnerComponentProps {
  thickness?: string;
  size?: string;
}

const SpinnerComponent: FC<SpinnerComponentProps> = ({
  thickness = "4px",
  size = "md",
}) => {
  return (
    <Spinner
      thickness={thickness}
      speed="0.65s"
      emptyColor="gray.300"
      color={primaryColor}
      size={size}
    />
  );
};

export default SpinnerComponent;
